import { NOTE_STATUS } from "@/services/api";
import type { Note } from "@/services/api";

export const getCircleColor = (note: Note | null | undefined): "red" | "grey" | "green" => {
  if (note?.status === NOTE_STATUS.DONE) {
    return "green";
  }
  if (note?.important) {
    return "red";
  }
  return "grey";
};
